import(/* webpackMode: "eager", webpackExports: ["CTACard"] */ "/app/components/cta/cta-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/components/layout/product-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoryReaderRouteClient"] */ "/app/components/reader/story-reader-route-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
